import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import DescriptionStylable from '../../../../../components/text/DescriptionStylable';
import AvatarV2 from '../../../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';

import { sportTypeIds } from '../../../../../utils/eventConstants';
import { getPickleBallRating, getRatingDetails, setRatingChoice } from '../../../../../utils';
import { titleCase } from '../../../../../utils/formatting';

import styles from './invitedPlayer.scss';

const InvitedPlayer = (props) => {
    const {
        player,
        sportTypeId,
        className,
        showDescription = true,
        'data-testid': dataTestId,
    } = props;

    const {
        firstName,
        lastName,
        playerProfileImages,
        gender,
        location,
        isPro,
        divisionName,
    } = player;

    const auth = useSelector(({ auth }) => auth);
    const userIsPowered = auth.user?.isPowered || false;

    const isPickleBall = sportTypeId === sportTypeIds.PICKLEBALL;

    const rating = isPickleBall
        ? getPickleBallRating(player, null)
        : getRatingDetails(setRatingChoice({ player }), userIsPowered, isPro, false, false);

    const descriptionItems = [
        ...(rating.showPBRRating ? [rating.pbrRating?.ratingDisplay] : [rating.value]),
        ...(gender ? [gender.charAt(0)] : []),
        ...(location?.display ? [location.display] : []),
    ];

    const playerName = `${firstName} ${lastName}`;

    return (
        <div
            className={`${styles.invitedPlayer} ${className}`}
            data-testid={dataTestId}
        >
            <AvatarV2
                playerImages={playerProfileImages}
                player={player}
                className={styles.playerImage}
            />
            <div className={styles.playerDetails}>
                <div className={`show-ellipsis`} data-testid={dataTestId && `${dataTestId}.name`}>
                    {titleCase(playerName)}  {rating.verified ? <div className="utr-icon icon-verified-blue d-inline-block" /> : ''}
                </div>
                {showDescription && (
                    <div className={`${styles.description} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.description`}>
                        <DescriptionStylable desc={descriptionItems} />
                    </div>
                )}
                {!!divisionName && (
                    <div className={`${styles.description} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.division-name`}>
                        {divisionName}
                    </div>
                )}
            </div>
        </div>
    );
};

InvitedPlayer.propTypes = {
    player: PropTypes.objectOf(any).isRequired,
    className: PropTypes.string,
    sportTypeId: PropTypes.number,
    showDescription: PropTypes.bool,
    'data-testid': PropTypes.string,
};

InvitedPlayer.defaultProps = {
    className: '',
    sportTypeId: sportTypeIds.TENNIS,
    showDescription: true,
    'data-testid': null,
};

export default InvitedPlayer;
